import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SingleContainer from '../SingleContainer/SingleContainer';
import initCompareCheckboxes from '../../../Compare/initCompareCheckboxes';

const ContainerWrapper = styled.div`
  display: flex;  
  flex-direction: row;
`;

const SelectedContainerWrapper = styled.div`

    margin: ${(props) => (props.displayRibbon ? '-20px' : '0')} 20px 0 0;
    
    @media ${(props) => props.theme.breakpoints.tablet} {
      margin: ${(props) => (props.displayRibbon ? '-20px' : '0')} 10px 0 0;
      width: auto;
    }
    
    @media ${(props) => props.theme.breakpoints.mobile} {
      display: none;
    }
`;

const SingleContainerWrapper = styled.div`
    margin: ${(props) => (props.displayRibbon ? '-20px' : '0')} 20px 0 0;
    
    @media ${(props) => props.theme.breakpoints.tablet} {
      margin: ${(props) => (props.displayRibbon ? '-20px' : '0')} 10px 0 0;
    }
    
    @media ${(props) => props.theme.breakpoints.mobile} {
      margin: ${(props) => (props.displayRibbon ? '-20px' : '0')} 10px 0 0;
    }
`;

const getProductParametersMaxLineLengths = (products) => {
  const maxLineLengths = [];
  for (let j = 0; j < products[0].productParameters.length; j++) {
    let maxLength = 0;
    for (let i = 0; i < products.length; i++) {
      const parameter = products[i].productParameters[j];
      if (parameter.value.length > maxLength) {
        maxLength = parameter.value.length;
      }
    }
    maxLineLengths[j] = maxLength;
  }
  return maxLineLengths;
};

const getProductFeatureMaxLineLengths = (products) => {
  const maxLineLengths = [];
  for (let j = 0; j < products.length; j++) {

    if (products[j].features !== undefined) {
      for (let i = 0; i < products[j].features.length; i++) {
        const feature = products[j].features[i];
        const maxLength = maxLineLengths[i] === undefined ? 0 : maxLineLengths[i];
        if (feature.label.length > maxLength) {
          maxLineLengths[i] = feature.label.length;
        }
      }
    }
  }
  return maxLineLengths;
};

const TradeUpContainer = ({ products, psaVariant }) => {

  useEffect(() => {
    if (window.digitalData) {
      initCompareCheckboxes();
    }
  }, []);

  const productParametersMaxLineLengths = getProductParametersMaxLineLengths(products);
  const productFeaturesMaxLineLength = getProductFeatureMaxLineLengths(products);

  const content = products.map((product, index) => {
    const displayRibbon = !!(product.tradeUpPrice || product.isActualProduct);
    const Wrapper = product.isActualProduct ? SelectedContainerWrapper : SingleContainerWrapper;
    return (
      <Wrapper
        key={product.productId}
        displayRibbon={displayRibbon}
      >
        <SingleContainer
          psaVariant={psaVariant}
          viewButtonOnClick={() => { window.top.location.href = product.productUrl; }}
          {...product}
          productParametersLineLengths={productParametersMaxLineLengths}
          productFeaturesMaxLineLength={productFeaturesMaxLineLength}
        />
      </Wrapper>
    );
  });

  return (
    <div>
      <ContainerWrapper>{content}</ContainerWrapper>
    </div>
  );
};

TradeUpContainer.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      isActualProduct: PropTypes.bool.isRequired,
      featuresHeaderText: PropTypes.string.isRequired,
      productTitle: PropTypes.string.isRequired,
      productImgUrl: PropTypes.string.isRequired,
      productUrl: PropTypes.string.isRequired,
      productParameters: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired,
          highlighted: PropTypes.bool.isRequired
        })
      ).isRequired,
      productFeatures: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired
        })
      ),
      reviewsCount: PropTypes.number.isRequired,
      rating: PropTypes.number.isRequired,
      productId: PropTypes.string.isRequired,
      productPrice: PropTypes.number.isRequired,
      tradeUpPrice: PropTypes.number.isRequired,
      productCurrency: PropTypes.string,
      buttonText: PropTypes.string.isRequired,
      buttonOnClick: PropTypes.func.isRequired,
      viewButtonText: PropTypes.string.isRequired
    })
  ).isRequired,
  psaVariant: PropTypes.string.isRequired
};

export default TradeUpContainer;
